import {
    STATUS_MESSAGE_SET,
    STATUS_MESSAGE_CLEAR
} from '../_actions/types'
import {StatusMessage} from '../types';

export type StatusMessageAction = {
    type: string;
    message: StatusMessage | null;
};

export type StatusMessageState = {
    message: StatusMessage | null;
};

const initialState: StatusMessageState = {
    message: null
};

export const reducer = (state: StatusMessageState = initialState, action: StatusMessageAction): StatusMessageState => {
    switch (action.type) {
        case STATUS_MESSAGE_SET:
            return {...state, message: action.message};
        case STATUS_MESSAGE_CLEAR:
            return {...state, message: null};
        default:
            return state;
    }
};